module.exports = __webpack_public_path__ + "static/media/task-seasonal.7724987d.svg";